<!-- step6/7/8/9... -->
<div class="main">
  <h4 [ngStyle]="{ 'margin-bottom.px': 16,'margin-top.px': 16 }">{{ 'DetailInfo.ReviewResult' | translate }}</h4>
  <div class="content">
    <div class="radio">
      <nz-radio-group [ngModel]="radioValue" (ngModelChange)="nzRadioChang($event)">
        <label nz-radio nzValue="agree">{{ 'DetailInfo.Approve' | translate }}</label>
        <label nz-radio nzValue="reject">{{ 'DetailInfo.Reject' | translate }}</label>
      </nz-radio-group>
    </div>
    <div [ngSwitch]="radioValue">
      <div *ngSwitchCase="'agree'">
        <div class="facAgreeRemark" *ngIf="step>5 && step <9">
          <input nz-input placeholder="{{'DetailInfo.ApprovePlaceholder' | translate}}" [(ngModel)]="agreeRemark"
            (ngModelChange)="nzInputChang($event,radioValue)" />
        </div>
        <!-- 如果是预算签核步骤,则同意时要填写预算编码 挂账部门 厂别 -->
        <div class="budgetCode-creditDepartment"
          *ngIf="((step == 9 && getProjectCategory === 0) || (step == 10 && getProjectCategory === 1))">
          <div class="budgetCode">
            <div class="spanValue">
              <span style="color: red;">*</span>
              <span>{{ 'ReviewResult.BudgetCode' | translate }}</span>
            </div>
            <input nz-input [(ngModel)]="budgetCode"
              (ngModelChange)="ngBudgetCodeAndCreditDepartmentChange($event,'budgetCode')"
              placeholder="{{ 'ReviewResult.BudgetCodePlaceholder' | translate }}" nzSize="default" />
          </div>
          <div class="creditDepartment">
            <div class="spanValue">
              <span style="color: red;">*</span>
              <span>{{ 'ReviewResult.CreditDept' | translate }}</span>
            </div>
            <input nz-input [(ngModel)]="creditDepartment"
              (ngModelChange)="ngBudgetCodeAndCreditDepartmentChange($event,'creditDepartment')"
              placeholder="{{ 'ReviewResult.CreditDeptPlaceholder' | translate }}" nzSize="default" />
          </div>
          <div class="plant">
            <div class="spanValue">
              <span style="color: red;">*</span>
              <span>{{ 'ReviewResult.CreditPlant' | translate }}</span>
            </div>
            <nz-select placeholder="{{ 'ReviewResult.CreditPlantPlaceholder' | translate }}" [(ngModel)]="plant"
              (ngModelChange)="ngBudgetCodeAndCreditDepartmentChange($event,'plant')" [nzOptions]="plantOption">
            </nz-select>
          </div>
        </div>
      </div>
      <div *ngSwitchCase="'reject'">
        <div *ngIf="step == 6;else template1">
          <div class="step6Remark">
            <div class="civil" *ngIf="civilEngineering">
              <label class="checkbox" nz-checkbox [ngModel]="civilChecked"
                (ngModelChange)="nzCheckChanged($event,'civil')">{{ 'DetailInfo.CIVIL' | translate }} {{'Budgets.Bid' |
                translate }}</label>
              <input *ngIf="civilChecked" nz-input placeholder="{{'DetailInfo.RejectPlaceholder' | translate}}"
                [(ngModel)]="civilRemark" (ngModelChange)="nzInputChang($event,'civil')" />
            </div>
            <div class="elec" *ngIf="electromechanical">
              <label class="checkbox" nz-checkbox [ngModel]="elecChecked"
                (ngModelChange)="nzCheckChanged($event,'elec')">{{ 'DetailInfo.ELECTRO' | translate }} {{'Budgets.Bid' |
                translate}}</label>
              <input *ngIf="elecChecked" nz-input placeholder="{{'DetailInfo.RejectPlaceholder' | translate}}"
                [(ngModel)]="electroRemark" (ngModelChange)="nzInputChang($event,'elec')" />
            </div>
          </div>
        </div>
        <ng-template  #template1>
          <input class="rejectRemark" nz-input placeholder="{{'DetailInfo.RejectPlaceholder' | translate}}" [(ngModel)]="rejectRemark"
            (ngModelChange)="nzInputChang($event)" />
        </ng-template>
      </div>
    </div>
  </div>
</div>